import { getAvatarColorClass } from './workspaceSelectorUtils';
import styles from './WorkspaceSelector.module.css';

interface WorkspaceAvatarProps {
  name: string;
  size?: 'sm' | 'md';
  shape?: 'circle' | 'rounded';
  className?: string;
}

const SIZE_CLASS = {
  sm: styles.avatarSm,
  md: styles.avatarMd,
} as const;

const SHAPE_CLASS = {
  circle: styles.avatarCircle,
  rounded: styles.avatarRounded,
} as const;

export function WorkspaceAvatar({
  name,
  size = 'md',
  shape = 'rounded',
  className,
}: WorkspaceAvatarProps) {
  const initial = name.charAt(0).toUpperCase();

  return (
    <span
      className={[
        styles.avatarBase,
        SIZE_CLASS[size],
        SHAPE_CLASS[shape],
        getAvatarColorClass(name),
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      aria-hidden="true"
    >
      {initial}
    </span>
  );
}
